<mat-card class="export-card">
  <app-card-header
    title="Exportar vehículos"
    [subtitle]="subtitulo"
    icono="table_view"
    [draggable]="false"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Tipo de exportación -->
    <section class="inputs-group">
      <irx-segmentado [(ngModel)]="tipoExport">
        <irx-segmento value="eventos">Eventos</irx-segmento>
        <irx-segmento value="reportes">Reportes</irx-segmento>
        <irx-segmento value="recorridos">Recorridos</irx-segmento>
        <irx-segmento value="zona">Por zona</irx-segmento>
      </irx-segmentado>
    </section>

    <!-- Banner informativo por tipo -->
    <section class="inputs-group">
      @if (tipoExport === 'eventos') {
        <app-info-banner
          icon="bolt"
          title="Exportación de eventos"
          message="Exporta los <b>eventos de alarma</b> registrados en el período seleccionado.<br><b>Requerido:</b> vehículo o cliente + rango de fechas.<br><b>Opcional:</b> seleccionar vehículo limita a ese vehículo; seleccionar cliente exporta todos sus vehículos."
          [closable]="false"
          margin="0"
          style="width: 100%"
        ></app-info-banner>
      } @else if (tipoExport === 'reportes') {
        <app-info-banner
          icon="summarize"
          title="Exportación de reportes"
          message="Exporta el <b>historial de posiciones y telemetría</b> del período seleccionado.<br><b>Requerido:</b> vehículo o cliente + rango de fechas.<br><b>Opcional:</b> incluir paradas y definir velocidad máxima para resaltar excesos."
          [closable]="false"
          margin="0"
          style="width: 100%"
        ></app-info-banner>
      } @else if (tipoExport === 'recorridos') {
        <app-info-banner
          icon="route"
          title="Exportación de recorridos"
          message="Exporta el <b>resumen de viajes</b> del vehículo: cada tramo con inicio, fin, duración, distancia y velocidad promedio/máxima.<br><b>Requerido:</b> vehículo + rango de fechas.<br><b>Opcional:</b> incluir eventos, paradas mínimas y umbral de exceso de velocidad."
          [closable]="false"
          margin="0"
          style="width: 100%"
        ></app-info-banner>
      } @else if (tipoExport === 'zona') {
        @if (zonaMode === 'vehiculosPorZona') {
          <app-info-banner
            icon="location_searching"
            title="Vehículos por zona"
            message="Exporta <b>qué vehículos pasaron por una zona</b> definida, con hora de entrada, salida y tiempo dentro.<br><b>Requerido:</b> zona (círculo/polígono en mapa o ubicación guardada) + rango de fechas.<br><b>Opcional:</b> filtrar por cliente o vehículo, tiempo mínimo en zona."
            [closable]="false"
            margin="0"
            style="width: 100%"
          ></app-info-banner>
        } @else {
          <app-info-banner
            icon="pin_drop"
            title="Zonas por vehículo"
            message="Exporta <b>qué ubicaciones guardadas visitó un vehículo</b>, con hora de entrada, salida y tiempo dentro.<br><b>Requerido:</b> vehículo + rango de fechas.<br><b>Opcional:</b> tiempo mínimo en zona."
            [closable]="false"
            margin="0"
            style="width: 100%"
          ></app-info-banner>
        }
      }
    </section>

    <!-- Qué exportar -->
    <app-content-card title="Alcance" icon="filter_alt">
      <section class="inputs-group">
        <!-- Vehículo (siempre visible, filtra por cliente si hay uno) -->
        <div class="campo">
          <ng-select
            [(ngModel)]="vehiculo"
            [items]="vehiculosFiltrados"
            [placeholder]="
              cargandoVehiculos ? 'Cargando vehículos...' : 'Vehículo'
            "
            notFoundText="No se encontraron vehículos"
            [loading]="cargandoVehiculos"
            [clearable]="true"
            [searchable]="true"
            [searchFn]="vehiculoSearchFn"
            [virtualScroll]="true"
            [dropdownPosition]="'auto'"
            appendTo="body"
          >
            <ng-template ng-option-tmp let-item="item">
              <span>{{ vehiculoLabel(item) }}</span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span>{{ vehiculoLabel(item) }}</span>
            </ng-template>
          </ng-select>
          <small class="ayuda">
            Buscá por patente o nombre.
            @if (
              tipoExport === 'recorridos' ||
              (tipoExport === 'zona' && zonaMode === 'zonasPorVehiculo')
            ) {
              Requerido.
            } @else if (tipoExport === 'eventos' || tipoExport === 'reportes') {
              Requerido si no hay cliente.
            } @else {
              Opcional.
            }
          </small>
        </div>

        <!-- Cliente -->
        @if (
          tipoExport !== 'recorridos' &&
          !(tipoExport === 'zona' && zonaMode === 'zonasPorVehiculo')
        ) {
          <div class="campo">
            <app-cliente-selector
              [filterModules]="['moduloVehiculos']"
              placeholder="Cliente"
              [clearable]="true"
              (clienteChange)="onClienteChange($event)"
            ></app-cliente-selector>
            <small class="ayuda">
              Filtra los vehículos.
              @if (tipoExport === 'eventos' || tipoExport === 'reportes') {
                Requerido si no hay vehículo.
              }
            </small>
          </div>
        }
      </section>

      <!-- Incluir hijos: sólo con cliente y sin vehículo seleccionado -->
      @if (cliente && !vehiculo) {
        <section class="inputs-group">
          <div class="campo">
            <mat-checkbox
              color="primary"
              [(ngModel)]="incluirHijos"
              [disabled]="hijosDeshabilitado"
            >
              Incluir clientes hijos
            </mat-checkbox>
            @if (hijosDeshabilitado) {
              <small class="ayuda error">
                El cliente tiene más de 300 hijos con vehículos ({{
                  totalVehiculosConHijos
                }}). No se puede incluir hijos.
              </small>
            }
          </div>
        </section>
      }
    </app-content-card>

    <!-- Rango de fechas -->
    <app-content-card title="Período" icon="date_range">
      <section class="inputs-group">
        <div class="campo">
          <app-date-picker
            mode="datetimerange"
            label="Rango de fechas"
            [(ngModel)]="rango"
          ></app-date-picker>
          <small class="ayuda" [class.error]="rangoExcedeMes">
            @if (rangoExcedeMes) {
              El rango no puede superar 31 días.
            } @else {
              Requerido, máximo 1 mes.
            }
          </small>
        </div>
      </section>
      <section class="inputs-group">
        <div class="presets">
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('esteMes')"
          >
            Este mes
          </button>
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('mesPasado')"
          >
            Mes pasado
          </button>
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('1semana')"
          >
            1 semana
          </button>
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('48h')"
          >
            48 horas
          </button>
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('24h')"
          >
            24 horas
          </button>
        </div>
      </section>
    </app-content-card>

    <!-- Opciones exclusivas de zona -->
    @if (tipoExport === 'zona') {
      <app-content-card title="Zona" icon="place">
        <section class="inputs-group">
          <irx-segmentado [(ngModel)]="zonaMode">
            <irx-segmento value="vehiculosPorZona">
              Vehículos por zona
            </irx-segmento>
            <irx-segmento value="zonasPorVehiculo">
              Zonas por vehículo
            </irx-segmento>
          </irx-segmentado>

          @if (zonaMode === 'vehiculosPorZona') {
            <irx-segmentado
              [(ngModel)]="zonaTipo"
              (ngModelChange)="onZonaTipoChange($event)"
            >
              <irx-segmento value="dibujo">
                Dibujar en mapa
              </irx-segmento>
              <irx-segmento value="ubicacion">
                Ubicación guardada
              </irx-segmento>
            </irx-segmentado>
          }
        </section>

        @if (zonaMode === 'vehiculosPorZona') {
          @if (zonaTipo === 'dibujo') {
            <section class="inputs-group" style="flex-direction: column">
              <div class="campo">
                <small class="ayuda zona-estado">
                  Requerido: dibujá un círculo o un polígono.
                  @if (zonaCirculoCenter) {
                    <span class="zona-definida">
                      <mat-icon>check</mat-icon>
                      Círculo definido
                    </span>
                  } @else if (zonaPoligono) {
                    <span class="zona-definida">
                      <mat-icon>check</mat-icon>
                      Polígono definido
                    </span>
                  }
                </small>
              </div>
              <div class="mapa-zona" style="height: 360px">
                <app-mapa-facil
                  [editingConfig]="zonaEditingConfig"
                ></app-mapa-facil>
              </div>
            </section>
          }

          @if (zonaTipo === 'ubicacion') {
            <section class="inputs-group" style="flex-direction: column">
              <div class="campo">
                <ng-select
                  [ngModel]="zonaUbicacion"
                  (ngModelChange)="onZonaUbicacionChange($event)"
                  [items]="zonaUbicaciones"
                  [loading]="cargandoUbicaciones"
                  [placeholder]="
                    cargandoUbicaciones
                      ? 'Cargando ubicaciones...'
                      : 'Ubicación guardada'
                  "
                  notFoundText="No se encontraron ubicaciones"
                  [clearable]="true"
                  [searchable]="true"
                  appendTo="body"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.identificacion }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.identificacion }}
                  </ng-template>
                </ng-select>
                <small class="ayuda">
                  @if (zonaUbicacion) {
                    Requerida.
                  } @else {
                    Requerida. Seleccioná una ubicación para verla en el mapa.
                  }
                </small>
              </div>
              <div class="mapa-zona" style="height: 300px">
                <app-mapa-facil
                  [editingConfig]="zonaUbicacionDisplayConfig"
                ></app-mapa-facil>
              </div>
            </section>
          }
        }

        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>Tiempo mínimo en zona (min)</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="zonaTiempoMinimo"
              min="0"
              placeholder="5"
            />
          </mat-form-field>
        </section>
      </app-content-card>
    }

    <!-- Opciones exclusivas de recorridos -->
    @if (tipoExport === 'recorridos') {
      <app-content-card title="Opciones" icon="tune">
        <section class="inputs-group">
          <mat-checkbox color="primary" [(ngModel)]="recorridoMostrarEventos">
            Incluir eventos
          </mat-checkbox>
        </section>
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>Tiempo mínimo detenido (min)</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="recorridoTiempoDetenido"
              min="0"
              placeholder="Sin paradas"
            />
          </mat-form-field>
          <mat-form-field style="width: 100%">
            <mat-label>Velocidad de exceso (km/h)</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="recorridoVelocidadExceso"
              min="0"
              placeholder="Sin exceso"
            />
          </mat-form-field>
        </section>
      </app-content-card>
    }

    <!-- Opciones exclusivas de reportes -->
    @if (tipoExport === 'reportes') {
      <app-content-card title="Opciones" icon="tune">
        <section class="inputs-group">
          <mat-checkbox color="primary" [(ngModel)]="incluirParadas">
            Incluir paradas
          </mat-checkbox>
        </section>
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>Velocidad máxima (km/h)</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="velocidadMaxima"
              min="0"
              placeholder="Sin límite"
            />
          </mat-form-field>
        </section>
      </app-content-card>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <span class="pie-espacio"></span>
    <button
      irxBoton="principal"
      type="button"
      [disabled]="!canExport"
      (click)="exportar()"
    >
      <mat-icon>download</mat-icon>
      {{ exportLabel }}
    </button>
  </mat-card-actions>
</mat-card>
